import React, { Component } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
export default class TestReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      columns: [
        {
          name: "Test",
          selector: "testName",
          sortable: true,
        },
        {
          name: "Course Name",
          selector: "courseName",
          sortable: true,
          right: true,
        },
        {
          name: "Completed",
          selector: "completed",
          sortable: true,
          right: true,
          cell: (row) => (
            <div className="d-flex">
              {row.completed ? <p>row.completed</p> : "-"}
            </div>
          ),
        },
        {
          name: "Passed",
          selector: "passed",
          sortable: true,
          right: true,
          cell: (row) => (
            <div className="d-flex">{row.passed ? <p>row.passed</p> : "-"}</div>
          ),
        },
        {
          name: "Average Score",
          selector: "averageScore",
          sortable: true,
          right: true,
          cell: (row) => (
            <div className="d-flex">
              {row.averageScore ? <p>row.averageScore</p> : "-"}
            </div>
          ),
        },
        {
          name: "Options",
          selector: "year",
          sortable: true,
          right: true,
          cell: (row) => (
            <div className="d-flex">
              <Link to={`/admin/reports/user/${row.id}`}>
                <i
                  class="btn btn-light shadow-sm mx-1 fas fa-pencil-alt text-dark"
                  id={row.id}
                ></i>
              </Link>
            </div>
          ),
        },
      ],
    };
  }
  componentDidMount() {
    //API will be placed here
  }
  render() {
    return (
      <div>
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /
                  <Link to="/admin/reports">Report</Link> /
                  <Link to="/admin/reports/test">Test Report</Link>
                </h5>
              </div>
            </div>
          </div>

          <div className="users-container p-2">
            <DataTable
              noHeader={true}
              columns={this.state.columns}
              data={this.state.data}
              theme="solarized"
              pagination={true}
            />
          </div>
        </div>
      </div>
    );
  }
}
